import tagTester from './_tagTester.js';

export default tagTester('ArrayBuffer');



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/isArrayBuffer.js
// module id = 288
// module chunks = 8